/**
 * @voltxampere/ui — TIP125 PNP Darlington pair variant (Sprint 44-2)
 *
 * Reference: TI TIP125 datasheet — TO-220 PNP Darlington pair
 * (TIP120 complement). V_CEO = -60 V, I_C = -5 A, β = 1000
 * (Darlington pair multiplied), V_BE(on) = -2.5 V (two junctions
 * cascaded), V_CE(sat) = -2.0 V.
 *
 *   Is ≈ 1e-12 A          (placeholder — Darlington internal Is)
 *   Bf = 1000             (Darlington β)
 *   Vaf = 80 V            (forward Early voltage)
 *
 * PLACEHOLDER NOTE: Aynı TIP120 ile, Darlington internal structure
 * gerçek modeli Sprint 50+'da. Şu anki stamp tek PNP BJT olarak
 * davranır.
 *
 * Engine zero-diff invariant honored — canonical `bjt-pnp` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { pnp } from "../pnp.js";
export const powerBjtTip125 = {
    id: "tip125",
    nameTr: "TIP125 (PNP Darlington, 60V/5A, TO-220)",
    nameEn: "TIP125 (PNP Darlington, 60V/5A, TO-220)",
    shortcut: "Q",
    category: "active",
    viewBox: pnp.viewBox,
    terminals: pnp.terminals,
    defaultLabel: "Q",
    defaultValue: "TIP125",
    schemaType: "bjt-pnp",
    defaultParams: { Is: 1e-12, Bf: 1000, Vaf: 80 },
    renderSVG: () => pnp.renderSVG(),
};
//# sourceMappingURL=power-bjt-tip125.js.map